import { NodeConfig } from 'ui/workflows/nodeTilePanel';
import { NodeType } from 'modules/workflows/types';
import { NODE_TYPES, ENABLED_NODES, TILE_TITLES } from './nodeConstants';
import { NODE_STRUCTURE_BY_TYPE } from './nodeData';
import { NODE_STYLE_CONFIGS } from './styles';

/**
 * This map will contain most of the data needed for any node - including
 * styles, initial node data, etc
 */
export const NODE_CONFIGS: Record<NodeType, NodeConfig> = Object.values(NODE_TYPES).reduce(
  (acc, nodeType) => ({
    ...acc,
    [nodeType]: {
      name: TILE_TITLES[nodeType],
      data: NODE_STRUCTURE_BY_TYPE[nodeType],
      // TODO: [WF-2575] remove static enabled nodes setting
      enabled: ENABLED_NODES.includes(nodeType),
      ...NODE_STYLE_CONFIGS[nodeType],
    },
  }),
  {},
);
